export default __webpack_public_path__ + "static/media/guest_fileShare_active.4aa766d8.svg";